<template>
<div :class="'custom-popup-modal ' + ( active ? 'active' : '')">
      <div class="custom-modal-wrapper height-auto">
         <div class="customer-model-content add-new-product-model text-white">
            <button class="close-btn" @click.prevent="callback">X</button>
             <slot name="content"></slot>
         </div>
      </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: 'CustomModal',
  props:{
    active:{ type: Boolean},
    callback: { type: Function }
  },
  
  data(){
    return { 
    }
  },
  computed: {
   
  },
  methods: {
  

  },
};
</script>